import React, { useRef, useEffect, useState } from 'react'
import DeviceOrientation, { Orientation } from 'react-screen-orientation'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  Container,
  IconButton,
  Typography,
  useMediaQuery, useTheme
} from '@mui/material'
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

import './camera.css'
import { UseImage, CustomAlertMaterial, CustomLoadingOverlay, Buttons, LinkButton, GeoLocationGeneric } from '../../components'
import { documentsActions } from '../../store/actions'
// import { useStyles } from './CameraStyles'
// import { mainStyles, theme } from '../../styles'
import { cargarDocsFunctions } from '../cargarDocs/CargarDocsFunctions'
import load_documentImg from '../../assets/load_document.svg'
import { useTranslation } from 'react-i18next'

export default function DocumentCameraCapture(props) {
  const matches = useMediaQuery('(max-width:800px)');
  const videoRef = useRef();
  const canvasRef = useRef();
  const theme = useTheme()
  const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()
  const localStyles = {}//useStyles()

  const [loadView, setLoadView] = useState(false)
  const [photoTaken, setPhotoTaken] = useState(false);
  const [showButtonHideOverlay, setShowButtonHideOverlay] = useState(false)
  const [ocrErrorAlert, setOcrErrorAlert] = useState(false)
  const [orientation, setOrientation] = useState(null)
  const [transId, setTransId] = useState(null)
  const [frontPhoto, setFrontPhoto] = useState(null)
  const [totalSections, setTotalSections] = useState(0)
  const [metadatos, setMetadatos] = useState([])
  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");
  const [textChangeLocation, setTextChangeLocation] = useState("");
  const [displayVideo, setDisplayVideo] = useState(null)

  const uploadSecDoc = useSelector(state => state.UploadSections)
  const uploadDoc = useSelector(state => state.UploadDocuments)
  const ocrResponse = useSelector(state => state.OcrData)

  const folioId = location.state.folioId
  const sectionId = location.state.sectionId
  const sections = location.state.sections
  const docName = location.state.docName
  const sectionName = location.state.sectionName
  const ocrInfo = location.state.ocrInfo
  const qrProcess = location.state.qrProcess
  const actorId = location.state.actorId
  const activeNSections = location.state.activeNSections
  const sectionsCapture = location.state.sectionsCapture

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation();

  // setFolioId(location.state.folioId)
  // setSectionId(location.state.sectionId)
  // const [folioId, setFolioId] = useState(0);
  // const [sectionId, setSectionId] = useState(0);

  let prepareBase64 = (photo) => {
    let base64 = photo
    // frontPhoto
    base64 = base64.split(',')
    return base64[1]
  }
  const dataToSend = {
    B64Content: frontPhoto ? prepareBase64(frontPhoto) : '',
    FileId: folioId,
    Actor_Id: actorId,
    SkipActor: null,
    SectionId: sectionId,
    Extension: '.jpg',
    Skip: false,
    SkipReason: null,
    Metadata: metadatos.length > 0 ? metadatos : null, //pending
    ContinueWorkFlow: false, //to upload all files before moving
    Geolocation: {
      Latitude: lat,
      Longitude: lon
    }, //Pending
    DeferLoad: false // heavy file, true to load on backgroud 
  }

  const dataforMetadata = {
    File_id: folioId,
    Carga: {
      Referencia: folioId.toString(),
      TransactionId: transId,
      EsBolqueFin: sections.length === totalSections && sections.length > 1 ? true
        : sections.length != totalSections && sections.length > 1 ? false : true,
      TipoDocumento: docName,
      Seccion: sectionName,
      Imagenes: [
        {
          B64: frontPhoto ? prepareBase64(frontPhoto) : '',
          Extension: '.pdf'
        }
      ],
      Metadatos: null
    }
  }

  useEffect(() => {
    window.addEventListener("orientationchange", () => {
      setOrientation(window.screen.orientation.type)
    })
  }); //It doesn't have [] because only affects the orientation Change

  let getVideo = () => {
    let constraints = {
      audio: false,
      video: {
        facingMode: 'environment',
        frameRate: { ideal: 13 },
        aspectRatio: 1.777777778,
        width: {
          min: 1280,
          ideal: 1920,
          max: 2560,
        },
        height: {
          min: 720,
          ideal: 1080,
          max: 1440
        },
        // width: { min: 1280 },
        // height: { min: 720 }
      }
    }
    console.log("Incio de camara")
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        console.log("Entro en camara de camara")
        setLoadView(false)
        videoRef.current.srcObject = stream
        videoRef.current.play()
      })
      .catch((error) => {
        if (error.message == "Permission denied") {
          console.error(error)
          alert(`Es necesario otorgar permisos de cámara para continuar: ${error.message}`)
        } else {
          console.error("Error en cámara: ", error.message)
          // alert(`Error en cámara: ${error.message}`)
        }
      })
  }

  useEffect(() => {
    getVideo()
    setTimeout(() => {
      setShowButtonHideOverlay(true)
    }, 4000)
  }, [photoTaken, orientation])

  useEffect(() => {
    if (photoTaken) {
      canvasRef.current.setAttribute(
        "width",
        videoRef.current.videoWidth
      )
      canvasRef.current.setAttribute(
        "height",
        videoRef.current.videoHeight
      )
      const context = canvasRef.current.getContext("2d")


      context.drawImage(
        videoRef.current, 0, 0, videoRef.current.videoWidth, videoRef.current.videoHeight
        // 60, 35, // Corte (left, top)
        // 525, 650,
        // 70, 60, // Posición del canvas
        // canvasRef.current.width , // - 180
        // canvasRef.current.height // + 550
      )


      if (!frontPhoto) {
        console.log("Tomo la  foto")
        setFrontPhoto(canvasRef.current.toDataURL("image/png"))
        handleCloseCamera()
      }
    }
  }, [photoTaken])

  function handleClick() {
    // console.log("ENtro en click: photoTaken--------frontPhoto-----------", photoTaken, frontPhoto)
    if (photoTaken) {
      if (frontPhoto != null) {
        setLoadView(true)
        // console.log("CargaSeccion-------------Carga INFO----VERIFY---------:  ", dataToSend)
        dispatch(documentsActions.CargaSeccion(dataToSend))
        // saveFrontPicture(frontPhoto)
      }
    }
    setPhotoTaken(true);
  }

  function handleCloseCamera() {
    try {
      let audioTrack = videoRef.current.srcObject.getAudioTracks();

      if (audioTrack.length > 0) {
        videoRef.current.srcObject.removeTrack(audioTrack[0]);

        let video = document.querySelector('video');
        video.src = videoRef.current.srcObject
      }

      let videoTrack = videoRef.current.srcObject.getVideoTracks();

      if (videoTrack.length > 0) {
        console.log("Entro remove track 1", videoRef.current?.srcObject)
        videoRef.current.srcObject.removeTrack(videoTrack[0]);
        console.log("Entro remove track 2", videoRef.current?.srcObject)

        let video = document.querySelector('video');
        console.log("Entro remove track 3", video.src, videoRef.current?.srcObject)
        video.src = videoRef.current?.srcObject
        console.log("Entro remove track 4", video.src, videoRef.current?.srcObject)
      }
      setDisplayVideo(false)
    } catch (ex) {
      console.log("Error al cerrar camara: ", ex)
    }
  }

  const backtoDocList = () => {
    handleCloseCamera();
    const noCurentCapture = (location.state.noCurentCapture + 1)
    const nextComponent = 'CargarDocsComponent'
    cargarDocsFunctions.nextIndocLoading({ navigate, folioId, nextComponent, qrProcess, docName, ocrInfo, sectionName, activeNSections, sectionsCapture, noCurentCapture })
  }

  const backtoDocListPdf = () => {
    const nextComponent = 'CargarDocsComponent'
    const pdf = true
    cargarDocsFunctions.nextIndocLoading({ navigate, folioId, sectionId, nextComponent, docName, sectionName, ocrInfo, qrProcess, pdf })
  }

  useEffect(() => {

    if (uploadSecDoc.items != undefined && uploadSecDoc.items?.Result != undefined && loadView) {
      if (uploadSecDoc.items.Result?.Id != null || uploadSecDoc.items.Result?.Id != undefined) {
        backtoDocList()
      }
    }
    if (uploadSecDoc.error != undefined && loadView) {
      alert(uploadSecDoc.error)
      setLoadView(false)
    }
  }, [uploadSecDoc])

  const askforTransactionId = () => {
    console.log("Entro askforTransactionId:-----------------------:  ", dataforMetadata)
    setLoadView(true)
    dispatch(documentsActions.CargaDocumento(dataforMetadata))
  }

  useEffect(() => {
    if (uploadDoc.items != undefined && uploadDoc.items?.TransactionId != null && loadView) {
      localStorage.setItem('TransactionId', uploadDoc.items.TransactionId)//Almacenar TransactionId
      // setTransId(uploadDoc.items.TransactionId)
      dispatch(documentsActions.GetOcrData(uploadDoc.items.TransactionId))
    }
    if (uploadDoc.error != undefined && loadView) {
      alert(uploadDoc.error)
      setLoadView(false)
    }
  }, [uploadDoc])

  useEffect(() => {
    if (ocrResponse.items != undefined && ocrResponse.items?.Metadatos != null && loadView) {
      if (ocrResponse.items.Metadatos[0].Name == "ProcessError") {
        setOcrErrorAlert(true)
        setLoadView(false)
      } else if (ocrResponse.items.Metadatos[0].Name != "ProcessError") {
        setMetadatos(ocrResponse.items.Metadatos)
      }
    } if (ocrResponse.error != undefined && loadView) {
      alert(ocrResponse.error)
      setLoadView(false)
    }
  }, [ocrResponse])

  useEffect(() => {
    if (metadatos.length > 0 && loadView) {
      const nextComponent = 'FormWebCamera'
      const doc = prepareBase64(frontPhoto)
      cargarDocsFunctions.nextIndocLoading({ navigate, folioId, sectionId, nextComponent, docName, qrProcess, metadatos, doc })

    }
  }, [metadatos])

  return (
    <div>
      <DeviceOrientation lockOrientation={"landscape"}>
        <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
          console.log("succes,latitude, longitude ", latitude, longitude);
          setLat(latitude);
          setLon(longitude);
        }}
          ErrorFN={(error) => console.log('error', error)}
        />
        <Orientation orientation="landscape" alwaysRender={false}>
          {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}

          <CustomAlertMaterial
            title='Volver a capturar'
            body='La extracción de datos no se pudo realizar, intenta volver a capturar la foto o adjuntar un documento'
            closeAction={() => setOcrErrorAlert(false)}
            open={ocrErrorAlert}
            leftButtonText='Subir Archivo PDF'
            leftButtonAction={backtoDocListPdf}
            rightButtonText='Reintentar'
            rightButtonAction={() => {
              setPhotoTaken(false)
              setShowButtonHideOverlay(false)
              setFrontPhoto(null)
              setOcrErrorAlert(false)
            }}
          />

          <div className={photoTaken && frontPhoto ? localStyles.photoContainer : localStyles.videoContainer}>
            {frontPhoto === null ? <video id="video" className={localStyles.video} ref={videoRef} hidden={photoTaken}></video> :
              <video id="video" className={localStyles.video} style={{ display: 'none' }} ref={videoRef} hidden={photoTaken}></video>
            }
            {photoTaken && frontPhoto && (
              <img
                className={localStyles.img}
                src={frontPhoto}
                alt="experiment" />

            )}
            <canvas ref={canvasRef} hidden></canvas>
            <div className={localStyles.overlayContainer}>
              {!showButtonHideOverlay && (
                <div className={localStyles.insideTextTip}>
                  <UseImage
                    className={localStyles.docIcon}
                    src={load_documentImg}
                  />
                  <Typography
                    variant={matches ? "subtitle1" : "h6"}
                    style={{ color: "white", marginTop: "10px" }}>
                    Enfoca el <b>documento</b> y presiona el botón para capturar la foto.
                  </Typography>
                </div>
              )}


              {showButtonHideOverlay && photoTaken &&
                <div className={localStyles.approvalSection}>
                  <IconButton
                    classes={{ root: localStyles.iconApproval }}
                    onClick={() => {
                      setPhotoTaken(false)
                      setShowButtonHideOverlay(false)
                      setFrontPhoto(null)
                    }}>
                    <ClearIcon style={{
                      color: '#ffffff',
                      width: '25px',
                      height: '25px'
                    }} />
                  </IconButton>
                  <IconButton
                    // ocrInfo.ocr == 0 ? handleClick : askforTransactionId
                    classes={{ root: localStyles.iconApproval }}
                    onClick={ocrInfo.ocr == 0 ? handleClick : askforTransactionId}>
                    <CheckIcon style={{
                      color: '#ffffff',
                      width: '25px',
                      height: '25px'
                    }} />
                  </IconButton>
                </div>
              }
              {!photoTaken && // showButtonHideOverlay && 
                <div className={localStyles.sectionToCapture}>
                  <LinkButton LinkButtonText="name button" LinkButtonUrl=""
                    text_size={15}
                    text_color='#ffffff'
                    text={t("general_cancel")}
                    type='button'
                    click={backtoDocList} />
                  <IconButton
                    classes={{ root: localStyles.iconButton }}
                    onClick={handleClick}>
                    <PhotoCameraIcon style={{
                      color: theme.palette.primary.main,
                      backgroundColor: '#ffffff',
                      width: '25px',
                      height: '25px'
                    }} />
                  </IconButton>
                </div>
              }
            </div>
          </div>
        </Orientation>

        <Orientation orientation="portrait" alwaysRender={false}>
          <Container>
            {/* <CssBaseline /> */}
            <Typography variant="h5" align="center">
              Please rotate your device
            </Typography>
          </Container>
        </Orientation>

      </DeviceOrientation>
    </div>
  );
}